<template>
  <div class="registration">
    <registration-header :data="data" :current="current" />

    <div class="registration_form">
      <div class="center">
        <Form
          :model="workInfo"
          label-position="top"
          class="text-left"
          ref="workInfo"
        >
          <section-header :name="$t('global.text28')" />
          <FormItem
            prop="displayName"
            :rules="[
              {
                required: true,
                message: $t('global.text13')
              }
            ]"
            :label="$t('global.text27')"
            class="test456456"
          >
            <Input
              class="input-text"
              style="width: 300px"
              maxlength="100"
              show-word-limit
              :placeholder="$t('global.text13')"
              v-model="workInfo.displayName"
            />
          </FormItem>
        </Form>
        <div v-for="v in data.groups" :key="v.group" :id="v.group">
          <div
            class="group-box"
            style="
              padding-bottom: 15px;
              margin-bottom: 15px;
              border-bottom: 1px solid #e8eaec;
            "
          >
            <p class="groupName text-left">
              {{ v.groupName }}
            </p>
            <p
              class="gary-text text-left"
              :class="{ statement: v.group === 'declarationAndSignature' }"
            >
              {{ v.description }}
            </p>
            <div
              class="add-new-item"
              v-if="v.group === 'education' || v.group === 'experience'"
              @click="addNewItem(v)"
            >
              <a class="ver-middle font-14">
                <Icon type="ios-add-circle-outline" size="20"></Icon>
                {{ $t('global.add') }}
              </a>
            </div>
          </div>

          <div
            class="content-box"
            v-if="
              v.group !== 'education' &&
              v.group !== 'experience' &&
              v.group !== 'emergencyContact'
            "
          >
            <Form
              :model="created_form[v.group]"
              :ref="v.group"
              :rules="rules[v.group]"
            >
              <template v-for="(val, k) in v.items">
                <div
                  :key="k"
                  class="content-item"
                  v-if="val.fieldName !== 'mobilePrefix'"
                >
                  <FormItem
                    :label="val.name"
                    :prop="val.fieldName"
                    v-if="val.fieldName !== 'expectedSalaryRange'"
                  >
                    <!-- text -->
                    <Input
                      class="input-text"
                      style="width: 100%"
                      :placeholder="setDescription(val)"
                      :maxlength="250"
                      show-word-limit
                      v-model="created_form[v.group][val.fieldName]"
                      v-if="
                        val.type === 'TEXT' &&
                        val.props.type !== 'NUMBER' &&
                        val.fieldName !== 'handwrittenSignatureImage'
                      "
                    >
                      <Select
                        v-if="
                          $_.indexOf(['phone', 'mobile'], val.fieldName) !== -1
                        "
                        v-model="created_form[v.group].mobilePrefix"
                        slot="prepend"
                        style="width: 100px"
                      >
                        <Option
                          v-for="(a, i) in areaCodeList"
                          :key="i"
                          :value="`${a.value}`"
                          :label="`+${a.value}`"
                        >
                          {{ a.key }}+{{ a.value }}
                        </Option>
                      </Select>
                    </Input>

                    <!-- number -->
                    <InputNumber
                      style="width: 100%"
                      :min="0"
                      v-model="created_form[v.group][val.fieldName]"
                      :placeholder="setDescription(val)"
                      :formatter="setNumberMax"
                      :parser="(value) => value"
                      v-if="val.type === 'TEXT' && val.props.type === 'NUMBER'"
                    ></InputNumber>

                    <!-- select -->
                    <Select
                      style="width: 100%; text-align: left"
                      v-model="created_form[v.group][val.fieldName]"
                      :multiple="val.props.selectMultiple"
                      v-if="
                        val.type === 'SELECT' && val.fieldName !== 'countryId'
                      "
                      :placeholder="setDescription(val)"
                    >
                      <template
                        v-if="
                          $_.indexOf(
                            ['mobilePrefix', 'countryId'],
                            val.fieldName
                          ) === -1
                        "
                      >
                        <Option
                          v-for="op in val.props.value"
                          :value="op.value"
                          :key="op.value"
                        >
                          {{ getLocaleValue(op.label) }}
                        </Option>
                      </template>
                    </Select>

                    <CountryCascader
                      v-model="countryIds"
                      :placeholder="setDescription(val)"
                      style="width: 100%; text-align: left"
                      @on-change="
                        onCountryCascaderChange($event, v.group, val.fieldName)
                      "
                      v-if="val.fieldName === 'countryId'"
                    />

                    <!-- date -->
                    <DatePicker
                      v-model="created_form[v.group][val.fieldName]"
                      v-if="val.type === 'DATE' && val.fieldName !== 'birth'"
                      type="date"
                      @on-change="created_form[v.group][val.fieldName] = $event"
                      style="width: 100%"
                      :placeholder="setDescription(val)"
                      :options="datePickerOptions"
                      @on-open-change="
                        onOpenDatePickerChange(
                          $event,
                          created_form[v.group],
                          val.fieldName
                        )
                      "
                    ></DatePicker>
                    <!-- 生日 -->
                    <DatePicker
                      v-model="created_form[v.group][val.fieldName]"
                      v-if="val.type === 'DATE' && val.fieldName === 'birth'"
                      type="date"
                      style="width: 100%"
                      :placeholder="setDescription(val)"
                      :options="datePickerOptions"
                      @on-open-change="
                        onOpenDatePickerChange(
                          $event,
                          created_form[v.group],
                          val.fieldName
                        )
                      "
                      @on-change="onDatePickerChange(created_form[v.group])"
                    ></DatePicker>
                    <!-- 手写签名 -->
                    <div v-if="val.fieldName === 'handwrittenSignatureImage'">
                      <Button @click="onSignOpen(v.groupName)">
                        {{ val.description }}
                      </Button>
                      <Row
                        class="sign-row"
                        type="flex"
                        align="middle"
                        :gutter="5"
                        v-if="signUrl"
                      >
                        <Col>
                          <div class="sign-image">
                            <img class="sign-img" :src="signUrl" alt="sign" />
                          </div>
                        </Col>
                        <Col>
                          <Icon
                            class="cur-p"
                            type="ios-trash-outline"
                            :size="25"
                            color="#ed4014"
                            @click="onSignDel"
                          />
                        </Col>
                      </Row>
                    </div>
                  </FormItem>
                </div>
              </template>
            </Form>
          </div>

          <!-- 工作经验和教育经验单独处理 -->
          <div
            class="content-box"
            v-if="
              v.group === 'education' ||
              v.group === 'experience' ||
              v.group === 'emergencyContact'
            "
          >
            <div
              v-for="(subItem, parentIndex) in created_form[v.group + 's']"
              :key="parentIndex + 'sdfsdfsdff'"
            >
              <Form :model="subItem" :ref="v.group + 's' + parentIndex">
                <template v-for="(val, subIndex) in v.items">
                  <div
                    :key="subIndex + 'dsfsdf21245'"
                    class="content-item"
                    v-if="val.fieldName !== 'mobilePrefix'"
                  >
                    <FormItem
                      :label="val.name"
                      :prop="val.fieldName"
                      :rules="
                        val.fieldName === 'phone'
                          ? checkPhone
                          : [
                              {
                                required:
                                  (v.group === 'experience' &&
                                    experienceRequired) ||
                                  v.group !== 'experience'
                                    ? val.requiredFlag
                                    : false,
                                message: setDescription(val)
                              }
                            ]
                      "
                    >
                      <!-- text -->
                      <Input
                        class="input-text"
                        @on-change="
                          changeArrayForm(v.group + 's', parentIndex, subItem)
                        "
                        style="width: 100%"
                        :placeholder="setDescription(val)"
                        :maxlength="250"
                        show-word-limit
                        v-model="subItem[val.fieldName]"
                        v-if="
                          val.type === 'TEXT' && val.props.type !== 'NUMBER'
                        "
                      >
                        <Select
                          v-if="
                            $_.indexOf(['phone', 'mobile'], val.fieldName) !==
                            -1
                          "
                          v-model="subItem.mobilePrefix"
                          slot="prepend"
                          style="width: 100px"
                        >
                          <Option
                            v-for="(a, i) in areaCodeList"
                            :key="i"
                            :value="`${a.value}`"
                            :label="`+${a.value}`"
                          >
                            {{ a.key }}+{{ a.value }}
                          </Option>
                        </Select>
                      </Input>

                      <!-- number -->
                      <InputNumber
                        @on-change="
                          changeArrayForm(v.group + 's', parentIndex, subItem)
                        "
                        style="width: 100%"
                        :min="0"
                        v-model="subItem[val.fieldName]"
                        :placeholder="setDescription(val)"
                        :formatter="setNumberMax"
                        :parser="(value) => value"
                        v-if="
                          val.type === 'TEXT' && val.props.type === 'NUMBER'
                        "
                      ></InputNumber>

                      <!-- select -->
                      <Select
                        @on-change="
                          changeArrayForm(v.group + 's', parentIndex, subItem)
                        "
                        style="width: 100%; text-align: left"
                        :multiple="val.props.selectMultiple"
                        v-model="subItem[val.fieldName]"
                        v-if="val.type === 'SELECT'"
                        :placeholder="setDescription(val)"
                      >
                        <Option
                          v-for="(op, o) in getOptions(val)"
                          :value="isAttOption(val) ? op.code : op.value"
                          :key="o"
                        >
                          {{
                            isAttOption(val)
                              ? op.name
                              : getLocaleValue(op.label)
                          }}
                        </Option>
                      </Select>

                      <!-- date -->
                      <DatePicker
                        v-model="subItem[val.fieldName]"
                        v-if="val.type === 'DATE'"
                        type="date"
                        @on-change="
                          changeArrayForm(v.group + 's', parentIndex, subItem)
                        "
                        style="width: 100%"
                        :placeholder="setDescription(val)"
                        :options="datePickerOptions"
                        @on-open-change="
                          onOpenDatePickerChange($event, subItem, val.fieldName)
                        "
                      ></DatePicker>
                    </FormItem>
                  </div>
                </template>
              </Form>
              <hr v-if="created_form[v.group + 's'].length > 1" />
              <Row
                type="flex"
                justify="end"
                align="center"
                v-if="created_form[v.group + 's'].length > 1"
              >
                <a
                  @click="onDeleteItem(v.group + 's', parentIndex)"
                  style="color: #ed4014"
                >
                  <Icon size="18" type="ios-remove-circle-outline" />
                  {{ $t('btn.delete') }}
                </a>
              </Row>
            </div>
          </div>
        </div>
      </div>
      <div class="anchor">
        <Anchor show-ink>
          <AnchorLink
            :title="$t('global.text28')"
            :class="{
              'ivu-anchor-link-active': anchorLinkActive === 'workInfo'
            }"
            @click.native="onAnchorSelect('workInfo')"
          />
          <AnchorLink
            v-for="(v, i) in data.groups"
            :key="`AnchorLink${i}`"
            :title="v.groupName"
            :class="{ 'ivu-anchor-link-active': v.group === anchorLinkActive }"
            @click.native="onAnchorSelect(v.group)"
          />
        </Anchor>
      </div>
    </div>
    <div class="registration-footer">
      <div class="registration-footer-flex">
        <Button v-if="current > 0 || $route.query.view" @click="handlePrev()">
          {{ $t('global.text18') }}
        </Button>
        <Button
          type="primary"
          :loading="sb_loading"
          @click="on_form_valid(true)"
        >
          {{ $t(`global.${!isHasNext ? 'text17' : 'text19'}`) }}
        </Button>
        <Button
          type="primary"
          v-if="isHasNext && !$route.query.view"
          :loading="sb_loading"
          ghost
          @click="on_form_valid"
        >
          {{ $t('global.text23') }}
        </Button>
      </div>
    </div>
    <handwritten-signature ref="handwrittenSignature" @on-ok="onSignOk" />
  </div>
</template>
<script>
import axios from 'axios';
import { mapState, mapMutations } from 'vuex';
import app_config from '@/commons/app_config';
import RegistrationHeader from './components/RegistrationHeader.vue';
import HandwrittenSignature from '@/components/handwritten-signature.vue';
import CountryCascader from '@/components/country-cascader.vue';
import scrollTo from '@/assets/js/scrollTo.js';
import { getLocaleValue } from '@/assets/js/multilingual-tools';
import localeToAreaCode from '@/assets/js/locale-to-area-code';
import SectionHeader from './components/SectionHeader.vue';

export default {
  data() {
    return {
      created_form: {},
      objectNames: {
        contactInfo: 'contact_info',
        personalInfo: 'personal_info',
        salaryInfo: 'salary_info',
        education: 'education',
        experience: 'experience',
        emergencyContact: 'emergency_contact',
        otherInfo: 'other_info'
      },
      workInfo: {
        displayName: null
      },
      sb_loading: false,
      areaCodeList: [],
      success: [],
      valid_edit: [],
      datePickerOptions: null,
      experienceRequired: true,
      checkPhone: [], // 紧急联系人电话号码验证
      signUrl: null,
      countryIds: [],
      mobilePrefix: null,
      anchorLinkActive: 'workInfo',
      attOptions: {
        JOB_TYPE: [],
        MARITAL: [],
        WORKING_VISA_TYPE: [],
        EDUCATION_LEVEL: []
      }
    };
  },
  components: {
    SectionHeader,
    RegistrationHeader,
    HandwrittenSignature,
    CountryCascader
  },
  computed: {
    ...mapState({
      data: (state) => _.cloneDeep(state.r_form),
      form: (state) => _.cloneDeep(state.form)
    }),
    isHasNext() {
      return this.data.attachments && this.data.attachments.length;
    },
    current() {
      const { guide } = this.data;
      const isGuide = guide && guide.enableFlag;
      if (isGuide) return 1;
      return 0;
    },
    rules() {
      if (this.sb_loading) return;
      const rules = {};
      _.forEach(this.data.groups, (e) => {
        rules[e.group] = {};
        _.forEach(e.items, (item) => {
          if (item.fieldName !== 'mobilePrefix') {
            if (!_.includes(['phone', 'mobile'], item.fieldName)) {
              rules[e.group][item.fieldName] = [
                {
                  required: item.requiredFlag,
                  message: this.setDescription(item)
                }
              ];
            }
            if (_.includes(['phone', 'mobile'], item.fieldName)) {
              const validatemobile = async (rule, value, callback) => {
                if (!value) {
                  return callback(
                    new Error(this.$t('global.enter_true_mobile_phone'))
                  );
                }
                if (this.created_form[e.group].mobilePrefix === '852') {
                  if (value.length !== 8) {
                    return callback(
                      new Error(this.$t('global.enter_true_mobile_phone'))
                    );
                  }
                } else {
                  if (
                    !this.$parsePhoneNumberFromString(
                      value,
                      `+${this.created_form[e.group].mobilePrefix}`
                    )
                  ) {
                    return callback(
                      new Error(this.$t('global.enter_true_mobile_phone'))
                    );
                  }
                }
                const mPattern = /[^\d]/g;
                if (mPattern.test(value)) {
                  return callback(
                    new Error(this.$t('global.enter_true_mobile_phone'))
                  );
                }
              };
              rules[e.group][item.fieldName] = [
                {
                  required: item.requiredFlag,
                  validator: validatemobile
                }
              ];
            }
            if (_.includes(['email', 'workEmail'], item.fieldName)) {
              rules[e.group][item.fieldName].push({
                type: 'email',
                message: this.$t('global.enter_true_work_email'),
                trigger: 'blur'
              });
            }
          }
        });
      });
      return rules;
    }
  },
  watch: {
    'created_form.careerObjective.currentWorkingStatus': {
      handler: function (newVal) {
        // 目前工作状态为应届毕业生时工作经验为非必填
        if (newVal === 'graduates') {
          this.experienceRequired = false;
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        } else {
          this.experienceRequired = true;
          this.$forceUpdate();
        }
      },
      deep: true
    }
  },
  created() {
    if (
      !sessionStorage.getItem('codeVerification') &&
      !this.$route.query.view
    ) {
      alert(this.$t('global.codeExpire'));
      this.$router.replace(
        `/registration/welcome/${this.$route.params.teamId}/${this.$route.params.registrationTemplateId}`
      );
    }
  },
  async mounted() {
    if (this.form && this.form.displayName) {
      this.workInfo.displayName = this.form.displayName;
    }
    await this.getMobilePrefixList();

    this.setApiData();
    // 根据是否有个人信息判断是新建还是编辑
    if (this.form.personalInfo) {
      this.setEditFormData(this.form);
    } else {
      // 带入电话信息
      this.initPhone();
    }
    await this.initAttOptions('MARITAL');
    await this.initAttOptions('WORKING_VISA_TYPE');
    await this.initAttOptions('EDUCATION_LEVEL');
    this.setCheckPhoneRule();
    const signUrl = sessionStorage.getItem('signUrl');
    const handwrittenSignatureImage = sessionStorage.getItem(
      'handwrittenSignatureImage'
    );

    if (signUrl && handwrittenSignatureImage) {
      this.signUrl = signUrl;
      this.created_form.declarationAndSignature.handwrittenSignatureImage =
        handwrittenSignatureImage;
    }
  },
  methods: {
    ...mapMutations({
      set_form: 'set_form',
      set_form1: 'set_form1'
    }),

    handlePrev() {
      const { params } = this.$route;
      const path =
        this.current === 0
          ? `/registration/welcome/${params.teamId}/${params.registrationTemplateId}`
          : this.$route.path.replace('form', 'guide');
      this.$router.push({
        path,
        query: {
          ...this.$route.query
        }
      });
    },

    async initAttOptions(code) {
      try {
        const { data } = await axios({
          method: 'GET',
          url: `${app_config.mainApiEndpoint}/rest/api/v1/public/attributes/${code}/options`,
          headers: {
            'X-TENANT-ID': this.$route.params.teamId
          }
        });
        this.attOptions[code] = data;
      } catch (error) {}
    },
    isAttOption(val) {
      return _.includes(
        ['workingVisaType', 'marital', 'educationLevel'],
        val.fieldName
      );
    },
    getOptions(val) {
      let options = val.props.value;
      if (
        _.includes(
          ['workingVisaType', 'marital', 'educationLevel'],
          val.fieldName
        )
      ) {
        const optCode = {
          workingVisaType: 'WORKING_VISA_TYPE',
          marital: 'MARITAL',
          educationLevel: 'EDUCATION_LEVEL'
        };
        const code = optCode[val.fieldName];
        options = this.attOptions[code];
      }
      return options;
    },
    // 获取多语言对应值
    getLocaleValue(data) {
      return getLocaleValue(data);
    },
    // 获取手机区号列表
    async getMobilePrefixList() {
      const res = await this.$http(
        'get',
        'public/dictionaries/area_code',
        { code: 'area_code' },
        true
      );
      this.areaCodeList = res.data.dictValues;
      try {
        const item = _.find(this.areaCodeList, (v) => {
          const extendedValue = v.extendedValue && JSON.parse(v.extendedValue);
          return (
            extendedValue &&
            extendedValue.countryCode === localeToAreaCode[this.$i18n.locale]
          );
        });
        const defaultValue =
          process.env.VUE_APP_REGION === 'yoov' ? '852' : '86';
        this.mobilePrefix = item ? `${item.value}` : defaultValue;
      } catch (e) {
        console.log(e);
      }
    },
    // 手写签名
    onSignOpen(name) {
      this.$refs.handwrittenSignature.open(name);
    },
    // 保存签名
    async onSignOk(e) {
      try {
        this.signUrl = e;
        sessionStorage.setItem('signUrl', e);
        if (!this.$route.query.view) {
          const params = this.$route.params;
          const form = new FormData();
          form.append('image', this.dataURLtoBlob(e));
          const res = await this.$http(
            'post',
            `recruitment/form/handwritten_signature/image/${params.teamId}/${params.formId}`,
            form,
            true
          );
          this.created_form.declarationAndSignature.handwrittenSignatureImage =
            res.data.name;
          sessionStorage.setItem('handwrittenSignatureImage', res.data.name);
          this.$refs.declarationAndSignature[0].validateField(
            'handwrittenSignatureImage'
          );
        }
      } catch (e) {
        this.$Message.error(this.$t('global.signSaveError'));
      }
    },
    // 删除签名
    async onSignDel() {
      try {
        if (!this.$route.query.view) {
          const params = this.$route.params;
          await this.$http(
            'delete',
            `recruitment/form/handwritten_signature/image/${params.teamId}/${params.formId}?name=${this.created_form.declarationAndSignature.handwrittenSignatureImage}`,
            {},
            true
          );
        }
        this.signUrl = null;
        this.created_form.declarationAndSignature.handwrittenSignatureImage =
          null;
      } catch (e) {
        this.$Message.error(this.$t('global.signDelError'));
      }
    },
    dataURLtoBlob(dataURI) {
      const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]; // mime类型
      const byteString = atob(dataURI.split(',')[1]); //base64 解码
      const arrayBuffer = new ArrayBuffer(byteString.length); //创建缓冲数组
      const intArray = new Uint8Array(arrayBuffer); //创建视图

      for (let i = 0; i < byteString.length; i++) {
        intArray[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([intArray], {
        type: mimeString
      });
      return new File([blob], `${new Date().getTime()}.png`);
    },
    // 限制数字长度
    setNumberMax(value) {
      const v = value.toString();
      const point = v.indexOf('.') > -1;
      const l = point ? 10 : 9;
      if (v.length > 9) {
        return v.substring(0, l);
      } else {
        return v;
      }
    },

    // 设置description
    setDescription(v) {
      if (v.description) {
        return v.description;
      } else {
        if (v.type === 'DATE' || v.type === 'SELECT') {
          return this.$t('i.select.placeholder');
        } else {
          return this.$t('i.textPlaceholder');
        }
      }
    },

    // 设置工资信息
    setSalaryInfo(data) {
      let list = [];
      for (let i of this.data.groups) {
        if (i.group === 'salaryInfo') {
          list = i.items;
        }
      }
      let obj = {};
      for (let i of data.attributes) {
        for (let j of list) {
          if (i.attribute.fieldName === j.fieldName) {
            if (j.type === 'SELECT' && j.props.selectMultiple) {
              obj[j.fieldName] = i.value && i.value.split(',');
            } else {
              obj[j.fieldName] = i.value;
            }
          }
        }
      }
      this.created_form.salaryInfo = obj;
    },
    // 设置個人信息
    setPersonalInfo(data) {
      let list = [];
      for (let i of this.data.groups) {
        if (i.group === 'personalInfo') {
          list = i.items;
        }
      }
      let obj = {};
      for (let i of data.attributes) {
        for (let j of list) {
          if (i.attribute.fieldName === j.fieldName) {
            if (j.type === 'SELECT' && j.props.selectMultiple) {
              obj[j.fieldName] = i.value && i.value.split(',');
            } else {
              obj[j.fieldName] = i.value;
            }
          }
        }
      }
      this.created_form.personalInfo = Object.assign(
        {},
        this.created_form.personalInfo,
        obj
      );
      // 设置国家级联选择器回显
      if (this.created_form.personalInfo.countryInfo) {
        this.countryIds =
          this.created_form.personalInfo.countryInfo.countryTreeId;
      }
    },
    // 国家选择
    onCountryCascaderChange(value, groupName, fieldName) {
      this.created_form[groupName][fieldName] = _.last(value);
    },
    // 设置聯係信息
    setContactInfo(data) {
      let list = [];
      for (let i of this.data.groups) {
        if (i.group === 'contactInfo') {
          list = i.items;
        }
      }
      let obj = {};
      for (let i of data.attributes) {
        for (let j of list) {
          if (i.attribute.fieldName === j.fieldName) {
            if (j.type === 'SELECT' && j.props.selectMultiple) {
              obj[j.fieldName] = i.value && i.value.split(',');
            } else {
              obj[j.fieldName] = i.value;
            }
          }
        }
      }
      this.created_form.contactInfo = Object.assign(
        {},
        this.created_form.contactInfo,
        obj
      );
    },
    // 设置紧急联系人电话号码校验
    setCheckPhoneRule() {
      let arr = [];
      for (let i of this.data.groups) {
        if (i.group === 'emergencyContact') {
          for (let j of i.items) {
            if (j.fieldName === 'phone') {
              let reuqired = {
                required: j.requiredFlag,
                message: j.description
              };
              arr.push(reuqired);
            }
          }
        }
      }
      // 如果有紧急联系人手机号码，则要校验手机号码是否正确
      if (arr.length < 1) return;
      let vm = this;
      let validateFun = {
        async validator(rule, value, callback, source, options) {
          if (!value) {
            return callback(new Error(vm.$t('global.enter_true_mobile_phone')));
          }

          if (vm.created_form.emergencyContacts[0].mobilePrefix === '852') {
            if (value.length !== 8) {
              return callback(
                new Error(vm.$t('global.enter_true_mobile_phone'))
              );
            }
          } else {
            if (
              !vm.$parsePhoneNumberFromString(
                value,
                `+${vm.created_form.emergencyContacts[0].mobilePrefix}`
              )
            ) {
              return callback(
                new Error(vm.$t('global.enter_true_mobile_phone'))
              );
            }
          }

          const mPattern = /[^\d]/g;
          if (mPattern.test(value)) {
            return callback(new Error(vm.$t('global.enter_true_mobile_phone')));
          }
        }
      };
      arr.push(validateFun);
      this.checkPhone = arr;
    },

    // 手动更改工作经验，教育经历，紧急联系人数组动态校验值
    changeArrayForm(groupName, index, item) {
      let _tempObj = _.cloneDeep(item);
      this.created_form[groupName][index] = '';
      this.$set(this.created_form[groupName], index, _tempObj);
    },

    setEditFormData(data) {
      try {
        if (data.declarationAndSignature) {
          this.created_form.declarationAndSignature.handwrittenSignatureImage =
            data.declarationAndSignature.handwrittenSignatureImage;
          this.signUrl =
            data.declarationAndSignature.handwrittenSignatureImageUrl;
        }
        // 其他信息要单独处理
        if (data.otherInfo) {
          this.dealOtherInfo(data.otherInfo);
        }
        if (data.salaryInfo) {
          this.setSalaryInfo(data.salaryInfo);
        }
        if (data.personalInfo) {
          this.setPersonalInfo(data.personalInfo);
        }
        if (data.contactInfo) {
          this.setContactInfo(data.contactInfo);
        }
      } catch (e) {}
    },
    onDeleteItem(key, index) {
      _.remove(this.created_form[key], (v, i) => {
        return i === index;
      });
      this.created_form[key] = [...this.created_form[key]];
    },

    // 设置其他信息
    dealOtherInfo(data) {
      let obj = {};
      if (data.attributes) {
        for (let i of data.attributes) {
          if (
            i.attribute.type === 'SELECT' &&
            i.attribute.props.selectMultiple
          ) {
            obj[i.attribute.fieldName] = i.value && i.value.split(',');
          } else {
            obj[i.attribute.fieldName] = i.value;
          }
        }
        this.created_form.otherInfo = obj;
      }
    },

    // 带入电话信息
    initPhone() {
      this.created_form.contactInfo.mobilePrefix = this.form.mobilePrefix;
      this.created_form.contactInfo.mobile = this.form.mobile;
    },

    // 设置后台接口绑定数据格式
    setApiData() {
      this.data.groups.forEach((v) => {
        if (
          v.group === 'education' ||
          v.group === 'experience' ||
          v.group === 'emergencyContact'
        ) {
          let name = v.group + 's';
          if (this.form[name] && this.form[name].length > 0) {
            this.$set(this.created_form, name, this.form[name]);
          } else {
            this.$set(this.created_form, name, []);
            let obj = {};
            let val = v.items;
            for (let i = 0; i < val.length; i++) {
              let newValue = '';
              // 设置手机号前缀
              if (val[i].fieldName === 'mobilePrefix') {
                const mobilePrefix = val[i].props.value[0];
                if (mobilePrefix) {
                  // 手机号前缀-区号
                  newValue = mobilePrefix;
                } else {
                  newValue = this.mobilePrefix;
                }
              } else {
                newValue = val[i].h_value ? val[i].h_value : null;
              }
              obj[val[i].fieldName] = newValue;
            }
            this.created_form[name][0] = obj;
          }
        } else {
          if (this.form[v.group]) {
            this.$set(this.created_form, v.group, this.form[v.group]);
          } else {
            this.$set(this.created_form, v.group, {});
            v.items.forEach((val) => {
              let value = val.h_value ? val.h_value : null;
              // 设置手机号前缀
              if (val.fieldName === 'mobilePrefix') {
                const mobilePrefix = val.props.value[0];
                if (mobilePrefix) {
                  // 手机号前缀-区号
                  value = mobilePrefix;
                } else {
                  value = this.mobilePrefix;
                }
              }
              if (val.fieldName === 'expectedSalaryRange') {
                let rangeVal = {
                  left: 0,
                  right: 0
                };
                value = rangeVal;
              }
              this.$set(this.created_form[v.group], val.fieldName, value);
            });
          }
        }
      });
    },

    // 新增项目，校验和工作经验
    addNewItem(group) {
      let index = this.created_form[group.group + 's'].length - 1;
      let newIndex = index + 1;
      let obj = this.created_form[group.group + 's'][0];
      let newObj = {};
      for (let i in obj) {
        newObj[i] = null;
      }
      this.$set(this.created_form[group.group + 's'], newIndex, newObj);
    },
    async _init_form() {
      const res = await axios({
        method: 'GET',
        url: `${app_config.mainApiEndpoint}/rest/api/v1/registration/form/${this.$route.params.teamId}/${this.$route.params.formId}`,
        headers: {
          'X-TENANT-ID': this.$route.params.teamId
        },
        data: this.formValidate
      });
      this.sb_loading = false;

      _.forEach(this.data.groups, (val) => {
        if (res.data[val.group]) {
          _.forEach(val.items, (val1) => {
            this.$set(
              val1,
              'h_value',
              res.data[val.group][val1.fieldName]
                ? res.data[val.group][val1.fieldName]
                : null
            );
          });
        }
      });
      this.set_form(this.data);
    },
    // 年龄判断
    onDatePickerChange(item) {
      if (this.$i18n.locale === 'hk') {
        // 香港地區僱傭兒童警告
        const curDate = this.$moment();
        const birth = this.$moment(item.birth);
        const difference = curDate.diff(birth, 'years');
        if (difference < 13) {
          item.birth = null;
          this.$Modal.warning({
            title: this.$t('global.warning'),
            content: this.$t('global.childrenWarningText')
          });
        } else if (difference > 12 && difference < 18) {
          this.$Modal.warning({
            title: this.$t('global.warning'),
            content: this.$t('global.underAgeWarningText')
          });
        }
      }
    },
    onOpenDatePickerChange(status, item, name) {
      if (!status) return;
      let datePickerOptions = null;
      // 生日
      if (name === 'birth') {
        let birth = null;
        datePickerOptions = {
          disabledDate(date) {
            const workDates = [
              item.firstWorkDate,
              item.workingVisaStartDate,
              item.workingVisaEndDate
            ];
            for (const value of workDates) {
              if (value) {
                let workDate = new Date(value);
                workDate = workDate.valueOf() - 86400000;
                birth = date && date.valueOf() > workDate;
              }
            }
            if (birth) {
              // 已选择首次工作时间或工作签证开始时间或工作签证结束时间
              return birth;
            } else {
              return date && date.valueOf() > Date.now();
            }
          }
        };
      }
      // 工作签证开始时间并且已选择首次工作时间
      if (name === 'workingVisaStartDate' && item.firstWorkDate) {
        datePickerOptions = {
          disabledDate(date) {
            let workDate = new Date(item.firstWorkDate);
            workDate = workDate.valueOf() - 86400000;
            return date && date.valueOf() < workDate;
          }
        };
      }
      // 工作签证结束时间并且已选择首次工作时间
      if (name === 'workingVisaEndDate' && item.firstWorkDate) {
        datePickerOptions = {
          disabledDate(date) {
            let workDate = new Date(item.firstWorkDate);
            workDate = workDate.valueOf();
            return date && date.valueOf() < workDate;
          }
        };
      }
      if (name === 'firstWorkDate') {
        datePickerOptions = {
          disabledDate(date) {
            return date && date.valueOf() > Date.now();
          }
        };
      }
      // 首次工作时间并且已选择工作签证开始时间或工作签证结束时间
      if (
        (name === 'firstWorkDate' && item.workingVisaStartDate) ||
        (name === 'firstWorkDate' && item.workingVisaEndDate)
      ) {
        datePickerOptions = {
          disabledDate(date) {
            const workingDate = item.workingVisaStartDate
              ? item.workingVisaStartDate
              : item.workingVisaEndDate;
            let workDate = new Date(workingDate);
            workDate = workDate.valueOf() - 86400000;
            return date && date.valueOf() > workDate;
          }
        };
      }
      // 首次工作时间并且已选择工作签证开始时间和工作签证结束时间
      if (
        name === 'firstWorkDate' &&
        item.workingVisaStartDate &&
        item.workingVisaEndDate
      ) {
        datePickerOptions = {
          disabledDate(date) {
            let workDate = new Date(item.workingVisaStartDate);
            workDate = workDate.valueOf() - 86400000;
            return date && date.valueOf() > workDate;
          }
        };
      }
      // 工作签证开始时间不能晚于工作签证结束时间
      if (name === 'workingVisaEndDate' && item.workingVisaStartDate) {
        datePickerOptions = {
          disabledDate(date) {
            let workDate = new Date(item.workingVisaStartDate);
            workDate = workDate.valueOf();
            return date && date.valueOf() < workDate;
          }
        };
      }
      // 工作签证开始时间并且已选择工作签证结束时间
      if (name === 'workingVisaStartDate' && item.workingVisaEndDate) {
        datePickerOptions = {
          disabledDate(date) {
            let workDate = new Date(item.workingVisaEndDate);
            workDate = workDate.valueOf() - 86400000;
            return date && date.valueOf() > workDate;
          }
        };
      }
      // 首次工作时间、工作签证开始时间、工作签证结束时间，并且已选择生日
      /* if (item.birth) {
        const workingNames = [
          "firstWorkDate",
          "workingVisaStartDate",
          "workingVisaEndDate"
        ];
        if (_.includes(workingNames, name)) {
          datePickerOptions = {
            disabledDate(date) {
              let workDate = new Date(item.birth);
              workDate = workDate.valueOf();
              return date && date.valueOf() < workDate;
            }
          };
        }
      } */
      // 教育、工作经验开始时间并且已选择教育、工作结束时间
      if (name === 'startedDate' && item.endedDate) {
        datePickerOptions = {
          disabledDate(date) {
            let workDate = new Date(item.endedDate);
            workDate = workDate.valueOf() - 86400000;
            return date && date.valueOf() > workDate;
          }
        };
      }
      // 教育、工作经验开始时间不能晚于结束日期
      if (name === 'endedDate' && item.startedDate) {
        datePickerOptions = {
          disabledDate(date) {
            let workDate = new Date(item.startedDate);
            workDate = workDate.valueOf();
            return date && date.valueOf() < workDate;
          }
        };
      }
      this.datePickerOptions = datePickerOptions;
    },
    async on_form_valid(is_next) {
      //預覽
      if (this.$route.query.view) {
        if (this.data.attachments.length > 0) {
          await this.$router.push({
            path: `/registration/attachment/${this.$route.params.teamId}/${this.$route.params.registrationTemplateId}/0?view=1`
          });
        } else {
          await this.$router.push({ path: '/registration/success' });
        }
      } else {
        // this.sb_loading = true;
        this.valid_edit = [];
        this.$refs['workInfo'].validate(async (w_v) => {
          if (w_v) {
            await _.forEach(this.data.groups, (v) => {
              if (
                v.group === 'education' ||
                v.group === 'experience' ||
                v.group === 'emergencyContact'
              ) {
                let arr = this.created_form[v.group + 's'];
                for (let i = 0; i < arr.length; i++) {
                  this.$refs[v.group + 's' + i][0].validate(async (valid) => {
                    if (!valid && this.valid_edit.indexOf(v.groupName) === -1) {
                      this.valid_edit.push(v.groupName);
                    }
                  });
                }
              } else {
                this.$refs[v.group][0].validate(async (valid) => {
                  if (!valid) {
                    this.valid_edit.push(v.groupName);
                  }
                });
              }
            });
            await this.valid_post(is_next);
          } else {
            this.valid_edit.push(this.$t('global.text28'));
            this.errorScroll();
          }
        });
      }
    },
    async valid_post(is_next) {
      if (this.valid_edit.length === 0) {
        const info = {
          otherInfo: [],
          salaryInfo: [],
          contactInfo: [],
          personalInfo: []
        };
        _.forEach(this.data.groups, (v) => {
          if (
            _.indexOf(
              ['otherInfo', 'salaryInfo', 'contactInfo', 'personalInfo'],
              v.group
            ) !== -1
          ) {
            _.forEach(v.items, (val) => {
              if (val.fieldType === 1) {
                info[v.group].push({
                  attribute: val,
                  value:
                    val.type === 'SELECT' && val.props.selectMultiple
                      ? _.toString(this.created_form[v.group][val.templateCode])
                      : this.created_form[v.group][val.templateCode]
                });
              }
            });
          }
        });
        this.created_form.contactInfo.attributes = info.contactInfo;
        this.created_form.personalInfo.attributes = info.personalInfo;
        let formValidate = {
          declarationAndSignature: this.created_form.declarationAndSignature,
          displayName: this.workInfo.displayName,
          contactInfo: this.created_form.contactInfo,
          personalInfo: this.created_form.personalInfo,
          otherInfo: { attributes: info.otherInfo },
          salaryInfo: { attributes: info.salaryInfo },
          emergencyContacts: this.created_form.emergencyContacts
            ? this.created_form.emergencyContacts
            : [],
          educations: this.created_form.educations
            ? this.created_form.educations
            : [],
          experiences: this.created_form.experiences
            ? this.created_form.experiences
            : []
        };
        await this.on_submits(formValidate, is_next);
      } else {
        this.$Message.error(
          `${this.valid_edit.join(',')}${this.$t('apply.not_empty')}`
        );
        this.errorScroll();
      }
    },

    next(is_next) {
      this.form.displayName = this.workInfo.displayName;
      this.form.contactInfo = this.created_form.contactInfo;
      this.form.otherInfo = this.created_form.otherInfo;
      this.form.personalInfo = this.created_form.personalInfo;
      this.form.salaryInfo = this.created_form.salaryInfo;
      this.form.declarationAndSignature =
        this.created_form.declarationAndSignature;
      if (this.created_form.emergencyContacts) {
        this.form.emergencyContacts = this.created_form.emergencyContacts;
      }
      if (this.created_form.educations) {
        this.form.educations = this.created_form.educations;
      }
      if (this.created_form.experiences) {
        this.form.experiences = this.created_form.experiences;
      }
      _.forEach(this.data.groups, (val) => {
        if (this.form[val.group]) {
          _.forEach(val.items, (val1) => {
            this.$set(
              val1,
              'h_value',
              this.created_form[val.group][val1.fieldName]
                ? this.created_form[val.group][val1.fieldName]
                : null
            );
          });
        }
      });
      this.set_form(this.data);
      this.set_form1(this.form);
      setTimeout(() => {
        this.sb_loading = false;
      }, 300);
      if (is_next) {
        if (this.data.attachments.length > 0) {
          this.$router.push({
            path: `/registration/attachment/${this.$route.params.teamId}/${this.$route.params.registrationTemplateId}/${this.$route.params.formId}`
          });
        } else {
          this.$router.push({ path: '/registration/success' });
        }
      }
    },
    async on_submits(formValidate, is_next) {
      try {
        this.sb_loading = true;
        // 时间各种转换
        this.convertTimeFormat(formValidate);
        const employeeId = this.$route.query.employeeId;
        const params = employeeId
          ? {
              ...formValidate,
              employeeId: Number(employeeId)
            }
          : formValidate;
        await axios({
          method: 'POST',
          url: `${app_config.mainApiEndpoint}/rest/api/v1/registration/form/${this.$route.params.teamId}/${this.$route.params.registrationTemplateId}/${this.$route.params.formId}/all`,
          headers: {
            'X-TENANT-ID': this.$route.params.teamId
          },
          data: params
        });
        this.next(is_next);
      } catch (e) {
        this.$Message.error({
          content: e.response.data.message,
          duration: 8
        });
        this.sb_loading = false;
      }
    },

    // 执行转换时间格式操作
    convertTimeFormat(data) {
      if (data.personalInfo.birth) {
        data.personalInfo.birth = this.$moment(data.personalInfo.birth).format(
          'YYYY-MM-DD'
        );
      }
      if (data.personalInfo.workingVisaEndDate) {
        data.personalInfo.workingVisaEndDate = this.$moment(
          data.personalInfo.workingVisaEndDate
        ).format('YYYY-MM-DD');
      }
      if (data.personalInfo.workingVisaStartDate) {
        data.personalInfo.workingVisaStartDate = this.$moment(
          data.personalInfo.workingVisaStartDate
        ).format('YYYY-MM-DD');
      }
      if (data.personalInfo.firstWorkDate) {
        data.personalInfo.firstWorkDate = this.$moment(
          data.personalInfo.firstWorkDate
        ).format('YYYY-MM-DD');
      }
      if (data.personalInfo.passportExpiredDate) {
        data.personalInfo.passportExpiredDate = this.$moment(
          data.personalInfo.passportExpiredDate
        ).format('YYYY-MM-DD');
      }
    },
    // 定位到表单错误位置
    errorScroll() {
      scrollTo('.ivu-form-item-error', '.registration');
    },
    // 定位到对应分类
    onAnchorSelect(value) {
      this.anchorLinkActive = value;
      const item = document.getElementById(value);
      document.querySelector('.registration').scrollTo({
        top: item.offsetTop,
        behavior: 'smooth'
      });
    }
  }
};
</script>
<style lang="less" scoped>
hr {
  border: none;
  height: 1px;
  background-color: #ccc;
  margin-bottom: 10px;
}

.group-box {
  position: relative;
}

.add-new-item {
  display: inline-block;
  position: absolute;
  top: 10px;
  right: 10px;
}

.test456456.ivu-form-item {
  margin-bottom: 30px;
}

.test456456.ivu-form-item:after {
  clear: none;
}

.registration {
  overflow-y: scroll;
  height: 100vh;

  &-footer {
    background-color: #fff;
    box-shadow: 0px 2px 20px 0px rgba(11, 4, 84, 0.08);
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 56px;
    bottom: 0;
    width: 100%;
    gap: 12px;
    z-index: 100;

    &-flex {
      display: flex;
      gap: 12px;
    }

    .mobile-footer {
      display: none;
    }
  }
}

.registration_form {
  width: 1200px;
  box-sizing: content-box;
  box-shadow: 0px 2px 20px 0px rgba(11, 4, 84, 0.08);
  background-color: #fff;
  border-radius: 4px;
  padding: 24px;
  margin: 84px auto 84px auto;

  .anchor {
    width: 200px;
    position: fixed;
    right: 20px;
    top: 100px;
    text-align: left;

    /deep/ .ivu-anchor-link-title {
      white-space: pre-wrap;
    }
  }
}

/deep/ .ivu-tabs-bar {
  border-bottom: none;
}

/deep/ .ivu-tabs-tab {
  pointer-events: none;
}

/deep/ .warn-modal {
  .ivu-modal-header {
    border-bottom: none !important;

    .ivu-icon {
      font-size: 28px;
      color: #f90;
    }

    .title {
      vertical-align: middle;
      margin-left: 12px;
      font-size: 16px;
      color: #17233d;
      font-weight: 500;
    }
  }

  .ivu-modal-body {
    padding: 0 58px;
  }

  .ivu-modal-footer {
    border-top: none !important;
  }
}

.content-box {
  width: 100%;
  text-align: left;

  .content-item {
    width: 50%;
    display: inline-block;
    padding: 0 7px;
    vertical-align: top;
  }
}

@media only screen and (max-width: 768px) {
  .registration_form {
    width: 92%;
    padding: 15px 15px 100px 15px;

    .anchor {
      display: none;
    }

    .center {
      margin: 0;
      padding-left: 0;
      width: 100%;
    }
  }

  .registration-footer {
    .mobile-footer {
      display: block;
      width: 100%;

      button {
        width: 95%;
      }
    }

    .footer {
      display: none;
    }
  }

  .content-box .content-item {
    width: 100%;
  }
}

/deep/ .input-text .ivu-input {
  padding-right: 58px;
}

.statement {
  white-space: pre-line;
}

.sign-row {
  margin: 10px 0 0 0 !important;
}

.sign-image {
  width: 200px;
  background-color: #fff;

  .sign-img {
    width: 100%;
  }
}
</style>
